module.exports = __webpack_public_path__ + "img/ruler&pen.89c45259.svg";